// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"8918cfc2","453":"2d7835ba"}[chunkId] + ".chunk.js";
};